import { useSelector } from "react-redux";
import { useMemo } from "react";
import { useRouter } from "next/router";
import { round } from "lodash";
import styles from "./index.module.scss";
import Icon from "../../../../common/icon";

export default function InstallPrice({ product }) {
  const catalog = product.CATALOG;

  const { sections } = useSelector((state) => state.sections);

  const { user } = useSelector((state) => state.user);

  const { cityName } = useSelector((state) => state.location);

  const installPrice = useMemo(() => {
    if (!sections[product.IBLOCK_SECTION_ID]?.UF_INSTALL_PRICE) {
      return 0;
    }
    const cityList = {
      Москва: "msk",
      "Санкт-Петербург": "spb",
    };
    const cityCode = cityList[cityName];
    if (!cityCode) {
      return 0;
    }

    const sectionHourPrices = {};
    sections[product.IBLOCK_SECTION_ID].UF_INSTALL_PRICE.forEach((item) => {
      const itemArray = item.split(":");
      sectionHourPrices[itemArray[0]] = +itemArray[1];
    });
    const installPriceForCity = sectionHourPrices[cityCode];
    if (installPriceForCity && product.VREMYA_USTANOVKI) {
      let price = round((installPriceForCity / 60) * product.VREMYA_USTANOVKI);
      if (product.INSTALL_COEFFICIENT) {
        price = round((price * product.INSTALL_COEFFICIENT) / 100);
      }
      return price;
    }
    return 0;
  }, [product, catalog, cityName]);

  const { contactsData } = useSelector((state) => state.contacts);
  const router = useRouter();

  return (
    <>
      {false &&
        installPrice > 0 &&
        (user?.IS_ADMIN || Boolean(router.query.demo)) && (
          <div className={styles.Install}>
            <span className={styles.Hint}>
              <Icon id={"i"} fill width={20} height={20} />
              <span className={styles.HintText}>
                Стоимость установки носит исключительно информационный характер,
                за более подробной консультации вы можете обратиться по
                телефону:
                <br /> {contactsData.PHONE}
              </span>
            </span>
            <span>С установкой +{installPrice} руб</span>
          </div>
        )}
      {installPrice > 0 && (user?.IS_ADMIN || user?.IS_MANAGER) && (
        <div className={styles.InstallManager}>
          <div>Время установки - {product.VREMYA_USTANOVKI} мин</div>
          {/* {product.INSTALL_COEFFICIENT > 0 && ( */}
          {/*   <div>коэффициент - {product.INSTALL_COEFFICIENT}</div> */}
          {/* )} */}
        </div>
      )}
    </>
  );
}
